<ion-content #pageTop class="background">
  <div class="header-page">
    <app-header-not-buttons></app-header-not-buttons>

    <app-title-three title="Mis datos"></app-title-three>
  </div>

  <form [formGroup]="updateProfileForm">
    <ion-grid class="form-data">
      <ion-row>
        <ion-col size="12" class="ion-text-justify">
          <ion-item>
            <ion-label position="floating">Nombres</ion-label>
            <ion-input mode="md" formControlName="first_name" maxlength="50" id="first_name"> </ion-input>
          </ion-item>

          <div class="div" *ngIf="errorControl.first_name.errors != null">
            <ion-text
              color="primary"
              class="text-12"
              *ngIf="( errorControl.first_name.touched ||  errorControl.first_name.dirty) &&  errorControl.first_name.errors.nameNumberMin"
              >Debe tener más de 2 letras.
            </ion-text>

            <ion-text
              color="primary"
              class="text-12"
              *ngIf="( errorControl.first_name.touched ||  errorControl.first_name.dirty) &&  errorControl.first_name.errors.nameNumberMax"
              >Debe tener máximo 50 caracteres.
            </ion-text>

            <ion-text
              color="primary"
              class="text-12"
              *ngIf="( errorControl.first_name.touched ||  errorControl.first_name.dirty) &&  errorControl.first_name.errors.nameText"
              >Los nombres solo debe contener letras.
            </ion-text>

            <ion-text
              color="primary"
              class="text-12"
              *ngIf="( errorControl.first_name.touched ||  errorControl.first_name.dirty) &&  errorControl.first_name.errors.nameRequerid"
              >Los nombres son requeridos.
            </ion-text>
          </div>

          <ion-item>
            <ion-label position="floating">Apellidos</ion-label>
            <ion-input mode="md" formControlName="last_name" maxlength="50" id="last_name"> </ion-input>
          </ion-item>

          <div class="div" *ngIf="errorControl.last_name.errors != null">
            <ion-text
              color="primary"
              class="text-12"
              *ngIf="( errorControl.last_name.touched ||  errorControl.last_name.dirty) &&  errorControl.last_name.errors.nameNumberMin"
              >Debe tener más de 2 letras.
            </ion-text>

            <ion-text
              color="primary"
              class="text-12"
              *ngIf="( errorControl.last_name.touched ||  errorControl.last_name.dirty) &&  errorControl.last_name.errors.nameNumberMax"
              >Debe tener máximo 50 caracteres.
            </ion-text>

            <ion-text
              color="primary"
              class="text-12"
              *ngIf="( errorControl.last_name.touched ||  errorControl.last_name.dirty) &&  errorControl.last_name.errors.nameText"
              >Los apellidos solo debe contener letras.
            </ion-text>

            <ion-text
              color="primary"
              class="text-12"
              *ngIf="( errorControl.last_name.touched ||  errorControl.last_name.dirty) &&  errorControl.last_name.errors.nameRequerid"
              >Los apellidos son requeridos.
            </ion-text>
          </div>

          <ion-item>
            <ion-label position="floating">Email</ion-label>
            <ion-input  mode="md" formControlName="email" maxlength="50" id="email" readonly> </ion-input>
          </ion-item>

          <div *ngIf="errorControl.email.errors != null">
            <div
              *ngIf="( errorControl.email.touched ||  errorControl.email.dirty) &&  errorControl.email.errors.nameNumberMin"
            >
              <ion-text color="primary" class="text-12">Debe tener más de 6 letras.</ion-text>
            </div>
            <div
              *ngIf="( errorControl.email.touched ||  errorControl.email.dirty) &&  errorControl.email.errors.nameNumberMax"
            >
              <ion-text color="primary" class="text-12">Debe tener máximo 50 caracteres.</ion-text>
            </div>
            <div
              *ngIf="( errorControl.email.touched ||  errorControl.email.dirty) &&  errorControl.email.errors.nameText"
            >
              <ion-text color="primary" class="text-12">Ingrese un correo válido.</ion-text>
            </div>
            <div
              *ngIf="( errorControl.email.touched ||  errorControl.email.dirty) &&  errorControl.email.errors.nameRequerid"
            >
              <ion-text color="primary" class="text-12">El correo es requerido.</ion-text>
            </div>
          </div>

          <!-- Provincia -->
          <ion-col size="6">
            <ion-item>
              <ion-label>{{"Provincia" | translate }} *</ion-label>
              <ionic-selectable
                #state
                formControlName="state_name"
                id="state_name"
                item-content
                itemValueField="name"
                itemTextField="name"
                [items]="states"
                [canSearch]="true"
                (onChange)="onStateChange()"
                closeButtonText="Cancelar"
                searchButtonText="Buscar"
                searchPlaceholder="Buscar"
                searchFailText="No se ha encontrado ningún registro"
              >
              </ionic-selectable>
            </ion-item>
            <div class="div message-errors" *ngIf="errorControl.state_name.errors != null">
              <div
                *ngIf="
                          (errorControl.state_name.touched ||
                            errorControl.state_name.dirty) &&
                          errorControl.state_name.errors.required
                        "
              >
                <ion-text color="primary" class="messages-alert"
                  >{{ "La provincia es requerida." | translate}}</ion-text
                >
              </div>
            </div>
          </ion-col>
        </ion-col>
      </ion-row>
      <!-- Localidad -->
      <ion-col size="6">
        <ion-item class="ml-16">
          <ion-label>{{"Localidad" | translate }} *</ion-label>
          <ionic-selectable
            #city
            formControlName="city_name"
            id="city_name"
            item-content
            itemValueField="name"
            itemTextField="name"
            [items]="cities"
            [canSearch]="true"
            closeButtonText="Cancelar"
            searchButtonText="Buscar"
            (onChange)="loadPrefix()"
            searchPlaceholder="Buscar"
            searchFailText="No se ha encontrado ningún registro"
          >
          </ionic-selectable>
        </ion-item>
        <div class="div message-errors" *ngIf="errorControl.city_name.errors != null">
          <div
            *ngIf="
                          (errorControl.city_name.touched ||
                            errorControl.city_name.dirty) &&
                          errorControl.city_name.errors.required
                        "
          >
            <ion-text color="primary" class="messages-alert">{{ "La localidad es requerida." | translate}}</ion-text>
          </div>
        </div>
      </ion-col>

      <ion-row>
        <ion-col size="12">
          <ion-label position="floating" color="tertiary">Teléfono 1 *</ion-label>
        </ion-col>
        <ion-col size="3">
          <ion-item *ngIf="validationReqPrefix">
            <p class="p-pt">(</p>
            <ion-input
              mode="md"
              formControlName="prefix"
              maxlength="5"
              id="prefix"
              type="text"
              class="center-text-input"
            >
            </ion-input>
            <p class="p-pt">) -</p>
          </ion-item>

          <div class="div message-errors" *ngIf="errorControl.prefix.errors != null">
            <div
              *ngIf="
                (errorControl.prefix.touched || errorControl.prefix.dirty) &&
                errorControl.prefix.errors.nameRequerid
              "
            >
              <ion-text color="primary" class="messages-alert">El {{ "Prefijo" | translate}} es requerido.</ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.prefix.touched || errorControl.prefix.dirty) &&
                errorControl.prefix.errors.nameNumberMax
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener máximo 5 caracteres. </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.prefix.touched || errorControl.prefix.dirty) &&
                errorControl.prefix.errors.nameText
              "
            >
              <ion-text color="primary" class="messages-alert">Ingrese un {{ "Prefijo" | translate}} válido.</ion-text>
            </div>
          </div>
        </ion-col>
        <ion-col size="9" class="col-pt">
          <ion-item>
            <ion-input mode="md" formControlName="phone_number" maxlength="15" id="phone_number" type="text">
            </ion-input>
          </ion-item>

          <div class="div message-errors" *ngIf="errorControl.phone_number.errors != null">
            <div
              *ngIf="
                (errorControl.phone_number.touched || errorControl.phone_number.dirty) &&
                errorControl.phone_number.errors.nameRequerid
              "
            >
              <ion-text color="primary" class="messages-alert">El numero de teléfono es requerido.</ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.phone_number.touched || errorControl.phone_number.dirty) &&
                errorControl.phone_number.errors.nameNumberMin
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener más de 2 caracteres. </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.phone_number.touched || errorControl.phone_number.dirty) &&
                errorControl.phone_number.errors.nameNumberMax
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener máximo 15 caracteres. </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.phone_number.touched || errorControl.phone_number.dirty) &&
                errorControl.phone_number.errors.nameText
              "
            >
              <ion-text color="primary" class="messages-alert">Ingrese una numero de celular valido.</ion-text>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <ion-label position="floating" color="tertiary">Teléfono 2</ion-label>
        </ion-col>
        <ion-col size="3">
          <ion-item *ngIf="validationReqPrefix">
            <p class="p-pt">(</p>
            <ion-input
              mode="md"
              formControlName="prefix_2"
              maxlength="15"
              id="prefix_2"
              type="text"
              class="center-text-input"
            >
            </ion-input>
            <p class="p-pt">) -</p>
          </ion-item>

          <div class="div message-errors" *ngIf="errorControl.prefix_2.errors != null">
            <div
              *ngIf="
                (errorControl.prefix_2.touched || errorControl.prefix_2.dirty) &&
                errorControl.prefix_2.errors.nameRequerid
              "
            >
              <ion-text color="primary" class="messages-alert">El {{ "Prefijo" | translate}} es requerido.</ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.prefix_2.touched || errorControl.prefix_2.dirty) &&
                errorControl.prefix_2.errors.nameNumberMax
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener máximo 5 caracteres. </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.prefix_2.touched || errorControl.prefix_2.dirty) &&
                errorControl.prefix_2.errors.nameText
              "
            >
              <ion-text color="primary" class="messages-alert">Ingrese un {{ "Prefijo" | translate}} válido.</ion-text>
            </div>
          </div>
        </ion-col>
        <ion-col size="9" class="col-pt">
          <ion-item>
            <ion-input mode="md" formControlName="phone_number_2" maxlength="15" id="phone_number" type="text">
            </ion-input>
          </ion-item>

          <div class="div message-errors" *ngIf="errorControl.phone_number_2.errors != null">
            <div
              *ngIf="
                (errorControl.phone_number_2.touched || errorControl.phone_number_2.dirty) &&
                errorControl.phone_number_2.errors.nameRequerid
              "
            >
              <ion-text color="primary" class="messages-alert">El numero de teléfono es requerido.</ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.phone_number_2.touched || errorControl.phone_number_2.dirty) &&
                errorControl.phone_number_2.errors.nameNumberMin
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener más de 2 caracteres. </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.phone_number_2.touched || errorControl.phone_number_2.dirty) &&
                errorControl.phone_number_2.errors.nameNumberMax
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener máximo 15 caracteres. </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.phone_number_2.touched || errorControl.phone_number_2.dirty) &&
                errorControl.phone_number_2.errors.nameText
              "
            >
              <ion-text color="primary" class="messages-alert">Ingrese una numero de celular valido.</ion-text>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12" class="ion-text-justify">
          <div *ngIf="permissions[1]">
            <ion-item
              [ngClass]="{'input-error': ( errorControl.specialty_name.touched ||  errorControl.specialty_name.dirty) &&  errorControl.specialty_name.errors}"
            >
              <ion-label color="tertiary" class="label-input">Especialidad </ion-label>
              <ionic-selectable
                #state
                formControlName="specialty_name"
                id="specialty_name"
                item-content
                itemValueField="name"
                itemTextField="name"
                [items]="specialties"
                [canSearch]="true"
                closeButtonText="Cancelar"
                searchButtonText="Buscar"
                searchPlaceholder="Buscar"
                searchFailText="No se ha encontrado ningún registro"
              >
              </ionic-selectable>
            </ion-item>

            <div class="div message-errors" *ngIf="errorControl.specialty_name.errors != null">
              <div
                *ngIf="
            (errorControl.specialty_name.touched ||
              errorControl.specialty_name.dirty) &&
            errorControl.specialty_name.errors.required
          "
              >
                <ion-text color="primary" class="messages-alert">La Especialidad es requerida. </ion-text>
              </div>
            </div>
          </div>

          <div *ngIf="permissions[1]">
            <ion-item>
              <ion-label position="floating">{{ "Matrícula" | translate }} *</ion-label>
              <ion-input mode="md" formControlName="tuition" maxlength="30" id="tuition" [disabled]="true"> </ion-input>
            </ion-item>

            <div class="div message-errors" *ngIf="errorControl.tuition.errors != null">
              <div
                *ngIf="
                  (errorControl.tuition.touched || errorControl.tuition.dirty) &&
                  errorControl.tuition.errors.nameRequerid
                "
              >
                <ion-text color="primary" class="messages-alert">La identificación es requerida.</ion-text>
              </div>
              <div
                *ngIf="
                  (errorControl.tuition.touched || errorControl.tuition.dirty) &&
                  errorControl.tuition.errors.nameNumberMin
                "
              >
                <ion-text color="primary" class="messages-alert">Debe de tener más de 3 caracteres. </ion-text>
              </div>
              <div
                *ngIf="
                  (errorControl.tuition.touched || errorControl.tuition.dirty) &&
                  errorControl.tuition.errors.nameNumberMax
                "
              >
                <ion-text color="primary" class="messages-alert">Debe de tener máximo 50 caracteres. </ion-text>
              </div>
              <div
                *ngIf="
                  (errorControl.tuition.touched || errorControl.tuition.dirty) &&
                  errorControl.tuition.errors.nameText
                "
              >
                <ion-text color="primary" class="messages-alert">Ingrese una identificación valida.</ion-text>
              </div>
            </div>
          </div>

          <div>
            <ion-item>
              <ion-label position="floating">{{ "Cédula" | translate }} *</ion-label>
              <ion-input mode="md" formControlName="ced_user" maxlength="30" id="ced_user" [disabled]="true">
              </ion-input>
            </ion-item>

            <div class="div message-errors" *ngIf="errorControl.ced_user.errors != null">
              <div
                *ngIf="
                  (errorControl.ced_user.touched || errorControl.ced_user.dirty) &&
                  errorControl.ced_user.errors.nameRequerid
                "
              >
                <ion-text color="primary" class="messages-alert">La identificación es requerida.</ion-text>
              </div>
              <div
                *ngIf="
                  (errorControl.ced_user.touched || errorControl.ced_user.dirty) &&
                  errorControl.ced_user.errors.nameNumberMin
                "
              >
                <ion-text color="primary" class="messages-alert">Debe de tener más de 3 caracteres. </ion-text>
              </div>
              <div
                *ngIf="
                  (errorControl.ced_user.touched || errorControl.ced_user.dirty) &&
                  errorControl.ced_user.errors.nameNumberMax
                "
              >
                <ion-text color="primary" class="messages-alert">Debe de tener máximo 50 caracteres. </ion-text>
              </div>
              <div
                *ngIf="
                  (errorControl.ced_user.touched || errorControl.ced_user.dirty) &&
                  errorControl.ced_user.errors.nameText
                "
              >
                <ion-text color="primary" class="messages-alert">Ingrese una identificación valida.</ion-text>
              </div>
            </div>
          </div>

          <ion-item>
            <ion-label position="floating">Contraseña actual</ion-label>
            <ion-input
              mode="md"
              formControlName="password"
              maxlength="15"
              maxlength="15"
              id="password"
              [type]="typeInput"
            >
            </ion-input>
            <ion-icon slot="end" [name]="eyeImage" class="icon-password" (click)="changeImage()" mode="md"></ion-icon>
          </ion-item>

          <div class="div message-errors" *ngIf="errorControl.password.errors != null">
            <div
              *ngIf="
                (errorControl.password.touched || errorControl.password.dirty) &&
                errorControl.password.errors.nameRequerid
              "
            >
              <ion-text color="primary" class="messages-alert">La contraseña es requerida.</ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.password.touched || errorControl.password.dirty) &&
                errorControl.password.errors.nameNumberMin
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener más de 3 caracteres </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.password.touched || errorControl.password.dirty) &&
                errorControl.password.errors.nameNumberMax
              "
            >
              <ion-text color="primary" class="messages-alert">Debe de tener máximo 50 caracteres </ion-text>
            </div>
            <div
              *ngIf="
                (errorControl.password.touched || errorControl.password.dirty) &&
                errorControl.password.errors.nameText
              "
            >
              <ion-text color="primary" class="messages-alert">Ingrese una contraseña valida</ion-text>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>

  <ion-grid class="mt-20">
    <ion-row>
      <ion-col class="ion-text-center">
        <button shape="round" type="submit" id="btn-create" class="btn-primary" (click)="updateProfile()">
          Actualizar
        </button>
      </ion-col>

      <ion-col size="12" class="center">
        <button (click)="closeModal()" id="close-modal" shape="round" class="btn-primary btn-close">Cerrar</button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
